import { useState } from 'react';
import Header from '@packages/shared/core/common/components/layout/Header';
import { AreaOfGuidance, TopicToDiscussScreenProps } from '@packages/shared/core/quiz/entities';
import Image from '@packages/shared/core/common/components/common/Image';
import Banner from '@packages/shared/simple-simple-registration/components/Banner';
import ProgressBar from '@packages/shared/simple-simple-registration/components/ProgressBar';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import TopicToDiscussModalScreen from './TopicToDiscussModalScreen';
import styles from './TopicToDiscussScreen.module.scss';

const TopicToDiscussScreen = ({
  content,
  onChosen,
  index: activeStep,
  totalSteps,
  sendCustomAnswer,
  onOtherClick,
  goBack,
}: TopicToDiscussScreenProps) => {
  const [isModalShow, setIsModalShow] = useState(false);

  const onClick = (value: AreaOfGuidance) => {
    if (value === AreaOfGuidance.OTHER) {
      onOtherClick();
      setIsModalShow(true);
      return;
    }

    onChosen(value);
  };

  return (
    <>
      <div className={styles.background} />

      <Banner />

      <Header className={styles.header} menuClassName={styles.menu}>
        <ButtonBack className={styles.buttonBack} secondary onClick={goBack} />
      </Header>

      <div className={styles.container}>
        <ProgressBar
          className={styles.progressBar}
          title={content.progressTitle}
          steps={totalSteps}
          activeStep={activeStep}
        />

        <h2 className={styles.title}>{content.title}</h2>

        <ul className={styles.list}>
          {content.list.map(({ text, icon }) => (
            <li role="button" onClick={() => onClick(text)} key={text} className={styles.listItemWrapper}>
              <div className={styles.listItem}>
                <Image className={styles.icon} type="future" src={icon} alt={text} width={56} height={56} />

                <p className={styles.text}>{text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <TopicToDiscussModalScreen
        open={isModalShow}
        onClose={() => setIsModalShow(false)}
        onSendCustomAnswer={sendCustomAnswer}
        title={content.modalTitle}
        button={content.modalButton}
      />
    </>
  );
};

export default TopicToDiscussScreen;
